import React from 'react';

import { ShippyIcon } from './shippy-icon';

import style from './shippy-static-icon.module.less';

/**
 * Static Ask ShipStation icon component
 * Scaled to 24px × 24px for use in top navigation
 * @returns {React.ReactElement}
 */
export const ShippyStaticIcon = () => {
  return (
    <div className={style.container}>
      <ShippyIcon />
    </div>
  );
};
